import React from "react";

// Long Range brand logos — use the supplied artwork files verbatim. Never redraw or regenerate.
// The logo files carry a Desert Cream background that blends with the app background.

export function LogoLockup({ compact = false, className }) {
  const cls = className || (compact ? "h-9" : "h-12");
  return (
    <img
      src="/brand/lr-emblem.png"
      alt="Long Range, Strategic Business Systems"
      data-testid="lr-logo"
      className={`${cls} w-auto select-none`}
      draggable="false"
    />
  );
}

export function LogoHero({ className = "" }) {
  return (
    <img
      src="/brand/lr-horizontal.png"
      alt="Long Range, Strategic Business Systems. See farther. Plan better. Build stronger."
      data-testid="lr-logo-hero"
      className={`w-auto select-none ${className}`}
      draggable="false"
    />
  );
}

export function LogoSeal({ size = 160 }) {
  return (
    <img
      src="/brand/lr-seal.png"
      alt="Long Range"
      data-testid="lr-logo-seal"
      style={{ height: size }}
      className="w-auto select-none"
      draggable="false"
    />
  );
}

// Small engraved landscape line-motifs for assessment section transitions.
// These are decorative desert elements (not the Long Range logo/mark).
export function Motif({ kind = "sun", size = 96 }) {
  const ink = "#292A25";
  const clay = "#A65F42";
  const common = { fill: "none", stroke: ink, strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" };
  const svg = (children) => (
    <svg viewBox="0 0 120 80" width={size} height={size * 0.66} aria-hidden="true">{children}</svg>
  );
  switch (kind) {
    case "trail":
      return svg(<>
        <path d="M6 70 C30 66 34 50 54 48 C74 46 80 30 110 26" strokeDasharray="1 5" {...common} />
        <circle cx="110" cy="26" r="3" fill={clay} stroke="none" />
      </>);
    case "mesquite":
      return svg(<>
        <line x1="60" y1="72" x2="60" y2="40" {...common} />
        <path d="M60 46 C48 42 42 34 40 28 M60 44 C72 40 80 32 84 26 M60 40 C54 34 52 28 52 22 M60 42 C68 36 72 30 74 24" {...common} />
        <path d="M14 72 C40 66 80 66 106 72" stroke={ink} strokeWidth="1" fill="none" opacity="0.5" />
      </>);
    case "ocotillo":
      return svg(<>
        <path d="M60 74 C56 56 52 40 48 24 M60 74 C60 54 60 36 60 20 M60 74 C64 56 70 40 74 26" {...common} />
        <g fill={clay} stroke="none"><circle cx="47" cy="22" r="2.4" /><circle cx="60" cy="18" r="2.4" /><circle cx="75" cy="24" r="2.4" /></g>
      </>);
    case "fencepost":
      return svg(<>
        <line x1="30" y1="66" x2="30" y2="30" {...common} /><line x1="90" y1="66" x2="90" y2="34" {...common} />
        <line x1="24" y1="40" x2="96" y2="44" {...common} /><line x1="24" y1="52" x2="96" y2="56" {...common} />
        <path d="M8 68 C40 62 80 62 112 68" stroke={ink} strokeWidth="1" fill="none" opacity="0.5" />
      </>);
    default: // sun / horizon
      return svg(<>
        <path d="M34 52 A26 26 0 0 1 86 52" stroke={clay} strokeWidth="1.6" fill="none" />
        <line x1="10" y1="60" x2="110" y2="60" stroke={ink} strokeWidth="1.2" />
        <g stroke={clay} strokeWidth="1.2"><line x1="60" y1="14" x2="60" y2="6" /><line x1="30" y1="24" x2="25" y2="18" /><line x1="90" y1="24" x2="95" y2="18" /></g>
      </>);
  }
}
